#import "../../../../core/schema/fragments/B2bCustomerFull.graphql"

mutation (
  $input: B2bCustomerCreateInput!
) {
  createB2bCustomer(
    input: $input
  ) {
    ...B2bCustomerFull
  }
}
